<mat-card>
  <img *ngIf="imageUrl" mat-card-image [src]="imageUrl">
  <img *ngIf="!imageUrl" mat-card-image
    src="https://png.pngtree.com/png-vector/20191218/ourmid/pngtree-coming-soon-logo-vector-template-design-illustration-png-image_2091063.jpg">

  <mat-card-content *ngIf="title || content">
    <h2 class="text-center cut-text2" style="font-size: 162.5% !important; line-height: 1.15;">{{title}}</h2>
    <p [innerHTML]="clearContent" class="cut-text"></p>
  </mat-card-content>

  <mat-card-footer *ngIf="date">
    {{date|date:'full'}}
  </mat-card-footer>
  <mat-card-footer *ngIf="teacherName">
    <span>{{teacherName}}</span> <span style="float: right;">{{price}}</span>
  </mat-card-footer>
</mat-card>
